@if (pferd!=undefined) {
  <div>
    <mat-divider style='margin-bottom:10px; margin-Top: 10px;' ></mat-divider>
    <mat-tab-group class='TabGroup'  (selectedTabChange)="changeTabGroupPferd($event)">
      <mat-tab label="Versicherung" style="width:800px ; min-height: 200px">
        <div class='ContentTab'  style="width:100%; margin-top:40px; ">
          <mat-grid-list cols="3" rowHeight="40px" style="width:800px" >
            <mat-grid-tile rowspan="2"><div class="gridContentLeft">Beginn / Rechnung:</div></mat-grid-tile>
            <mat-grid-tile rowspan="2">
              <mat-form-field style="margin-top: 10px">
                <input matInput [matDatepicker]="V_Beginn"  [(ngModel)]="pferd.V_Beginn"  (ngModelChange)="onVBeginnChange()"  name="V_Beginn" >
                <mat-datepicker-toggle matSuffix [for]="V_Beginn"></mat-datepicker-toggle>
                <mat-datepicker #V_Beginn></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile rowspan="2">
              <mat-form-field style="margin-top: 10px">
                <input matInput [matDatepicker]="ErsteRechnung"  [(ngModel)]="pferd.ErsteRechnung"  name="ErsteRechnung" >
                <mat-datepicker-toggle matSuffix [for]="ErsteRechnung"></mat-datepicker-toggle>
                <mat-datepicker #ErsteRechnung></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile rowspan="2" ><div class="gridContentLeft">Versicherung Ende / Grund:</div></mat-grid-tile>
            <mat-grid-tile rowspan="2" colspan="1">
              <mat-form-field style="margin-top: 10px">
                <input matInput [matDatepicker]="V_Ende"  [(ngModel)]="pferd.V_Ende"  name="V_Ende" >
                <mat-datepicker-toggle matSuffix [for]="V_Ende"></mat-datepicker-toggle>
                <mat-datepicker #V_Ende></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <!--<mat-grid-tile rowspan="2"><div class="gridContentLeft">Grund für Abgang:</div></mat-grid-tile> -->
            <mat-grid-tile rowspan="2" colspan="1">
              <mat-form-field style="margin-top: 10px;  width: 95% !important;" >
                <mat-select    [(ngModel)]="pferd.Grund"  name="Grund">
                  <mat-option value="">---</mat-option>
                  <mat-option value="Todesfall">Todesfall</mat-option>
                  <mat-option value="Invalidität">Invalidität</mat-option>
                  <mat-option value="Kündigung (Kunde)">Kündigung (Kunde)</mat-option>
                  <mat-option value="Kündigung (Pasura)">Kündigung (Pasura)</mat-option>
                  <mat-option value="Export">Export</mat-option>
                  <mat-option value="Zahlungsverzug">Zahlungsverzug</mat-option>
                  <mat-option value="Spezielles">Spezielles</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Einschätzungspauschale in CHF</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              <input placeholder="VS" [(ngModel)]="pferd.EinschaetzungsPauschale"  name="EinschaetzungsPauschale" type="number" >
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Tarifgeneration:</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              {{pferd.Praemien.TarifGen}}
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Tarif-Typ:</div></mat-grid-tile>
            <mat-grid-tile colspan="2" style="">
              <mat-chip-listbox [multiple]="false">
                @for (sub of  globserv.tarifPferd.SubTarife ; track sub) {
                  <mat-chip-option
                    (click)="pferd.VArt=sub.TarifID; calcPraemie(pferd, police.FlottenRabatt);"
                    [selected]="pferd.VArt==sub.TarifID"
                    [selectable]="pferd.VArt!=sub.TarifID">
                    {{sub.MarketingName}} &nbsp;
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </mat-grid-tile>
            <mat-grid-tile rowspan="1"><div class="gridContentLeft">Produkt:</div></mat-grid-tile>
            <mat-grid-tile rowspan="1" colspan="2">
              <mat-chip-listbox [multiple]="false">
                @for (produkt of  globserv.tarifPferd.Produkte ; track produkt) {
                  <mat-chip-option  layout-align="end left"  selectable="true"
                    (click)="pferd.VProdukt=produkt.ProduktID; subTarif=produkt; calcPraemie(pferd, police.FlottenRabatt);"
                    [selected]="pferd.VProdukt==produkt.ProduktID"
                    [selectable]="pferd.VProdukt!=produkt.ProduktID">
                    {{getMarketingNameKurz(produkt.MarketingName)}} &nbsp;
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </mat-grid-tile>
            @if (globserv.tarifPferd!=undefined && globserv.tarifPferd.OptionenBK !=undefined && globserv.tarifPferd.Produkte[getProduktIdx(pferd.VProdukt)]!=undefined  ) {
              <div >
                <mat-grid-tile rowspan="1"><div class="gridContentLeft">Produkt-Option:</div></mat-grid-tile>
                <mat-grid-tile rowspan="1" colspan="2" >
                  <mat-chip-listbox [multiple]="false">
                    @for (opt of globserv.tarifPferd.OptionenBK; track opt) {
                      <mat-chip-option
                        layout-align="end left"
                        (click)="pferd.OptionBK=opt.OptionID; calcPraemie(pferd, police.FlottenRabatt);"
                        [selected]="pferd.OptionBK==opt.OptionID"
                        [selectable]="pferd.OptionBK !=opt.OptionID">
                        {{getMarketingNameKurz(opt.MarketingName)}} &nbsp;
                      </mat-chip-option>
                    }
                  </mat-chip-listbox>
                </mat-grid-tile>
                @if (hatSB(pferd.VProdukt)) {
                  <div class="abstandUnten">
                    <mat-grid-tile><div class="gridContentLeft">Selbstbehalt:</div></mat-grid-tile>
                    <mat-grid-tile colspan="2">
                      <mat-chip-listbox  >
                        @for (sb of getSelbstbehaltOptionenBK(pferd.OptionBK); track sb) {
                          <mat-chip-option  layout-align="end left"  selectable="true"
                            (click)="pferd.Selbstbehalt=getNumber(sb.ID); calcPraemie(pferd, police.FlottenRabatt);"
                            [selected]="pferd.Selbstbehalt==getNumber(sb.ID)"
                            [selectable]="pferd.Selbstbehalt!=getNumber(sb.ID)">
                            {{sb.Text}} &nbsp;
                          </mat-chip-option>
                        }
                      </mat-chip-listbox>
                    </mat-grid-tile>
                  </div>
                }
              </div>
            }
            <mat-grid-tile><div class="gridContentLeft">Optionen:</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              <mat-chip-listbox multiple >
                @for (opt of  globserv.tarifPferd.Optionen ; track opt) {
                  <mat-chip-option  layout-align="end left"  selectable="true"
                    (click)="toggleOption(opt, pferd.Optionen); calcPraemie(pferd, police.FlottenRabatt);"
                    [selected]="isSelOption(opt, pferd.Optionen)">
                    {{getMarketingNameKurz(opt.MarketingName)}} &nbsp;
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Versicherungssumme in CHF</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              <input placeholder="VS" [(ngModel)]="pferd.VS"  name="VS" type="number" (change)="calcPraemie(pferd, police.FlottenRabatt)">
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Prämie Total</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              @if (pferd.Praemien!=undefined) {
                <span>{{globserv.formatMoney(pferd.Praemien.PraemieTotal)}}</span>
              }
              <!--
              <button mat-button  *ngIf="calcOK()" style="margin-top: -10px"  (click)="calcPraemie(pferd)" >
                <mat-icon >cached</mat-icon>
              </button>
              -->
              @if (calcOK()) {
                <button mat-button  style="margin-top: -10px"  (click)="getPolicePDF(pferd.ID)" >
                  <mat-icon >picture_as_pdf</mat-icon>
                </button>
              }
            </mat-grid-tile>
            @if (pferd.Praemien!=undefined) {
              <div >
                @for (info of pferd.Praemien.Infos; track info) {
                  <div>
                    <mat-grid-tile></mat-grid-tile>
                    <mat-grid-tile colspan="2">
                      <div style="color: red;">{{info}}</div>
                    </mat-grid-tile>
                  </div>
                }
              </div>
            }
          </mat-grid-list>
        </div>
      </mat-tab>
      <mat-tab label="Pferd" style="width:800px ; min-height: 200px">
        <div class='ContentTab'  style="width:100%; margin-top:30px ;">
          <mat-grid-list cols="3" rowHeight="40px" style="width:800px" >
            <mat-grid-tile><div class="gridContentLeft">Name</div></mat-grid-tile>
            <mat-grid-tile>
              <input placeholder="Name" [(ngModel)]="pferd.Name"  name="Name" >
            </mat-grid-tile>
            <mat-grid-tile>
              <input placeholder="NameZusatz" [(ngModel)]="pferd.NameZusatz"  name="NameZusatz" >
            </mat-grid-tile>
            <mat-grid-tile rowspan="2"><div class="gridContentLeft">Datum Geburt</div></mat-grid-tile>
            <mat-grid-tile rowspan="2" colspan="2">
              <mat-form-field style="margin-top: -15px">
                <input matInput [matDatepicker]="GebDat"  [(ngModel)]="pferd.GebDat"  name="GebDat" >
                <mat-datepicker-toggle matSuffix [for]="GebDat"></mat-datepicker-toggle>
                <mat-datepicker #GebDat></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Geschlecht / Nutzung</div></mat-grid-tile>
            <mat-grid-tile >
              <mat-chip-listbox aria-label="Geschlecht">
                <mat-chip-option (click)="pferd.Sex='H'" [selected]="pferd.Sex=='H'" [selectable]="pferd.Sex!='H'" >Hengst</mat-chip-option>
                <mat-chip-option (click)="pferd.Sex='S'" [selected]="pferd.Sex=='S'" [selectable]="pferd.Sex!='S'" >Stute</mat-chip-option>
                <mat-chip-option (click)="pferd.Sex='W'" [selected]="pferd.Sex=='W'" [selectable]="pferd.Sex!='W'" >Wallach</mat-chip-option>
              </mat-chip-listbox>
            </mat-grid-tile>
            <mat-grid-tile >
              <mat-chip-listbox aria-label="Tierarzneimittelverordnung">
                <mat-chip-option (click)="pferd.Nutzung='Heimtier'" [selected]="pferd.Nutzung=='Heimtier'" [selectable]="pferd.Nutzung!='Heimtier'">Heimtier</mat-chip-option>
                <mat-chip-option (click)="pferd.Nutzung='Nutztier'"    [selected]="pferd.Nutzung=='Nutztier'" [selectable]="pferd.Nutzung!='Nutztier'">Nutztier</mat-chip-option>
              </mat-chip-listbox>
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Rasse / Grösse</div></mat-grid-tile>
            <mat-grid-tile >
              <input placeholder="Rasse" [(ngModel)]="pferd.Rasse"  name="Rasse">
            </mat-grid-tile>
            <mat-grid-tile >
              <input placeholder="Groesse" [(ngModel)]="pferd.Groesse"  name="Groesse" type="number">
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">Farbe / Zeichnung</div></mat-grid-tile>
            <mat-grid-tile>
              <input placeholder="Farbe" [(ngModel)]="pferd.Farbe"  name="Farbe">
            </mat-grid-tile>
            <mat-grid-tile>
              <input placeholder="Zeichnung" [(ngModel)]="pferd.Zeichnung"  name="Zeichnung">
            </mat-grid-tile>
            <mat-grid-tile><div class="gridContentLeft">PassChip</div></mat-grid-tile>
            <mat-grid-tile colspan="2">
              <input placeholder="PassChip" [(ngModel)]="pferd.PassChip"  name="PassChip">
            </mat-grid-tile>
            <mat-grid-tile rowspan="2"><div class="gridContentLeft">Bemerkung</div></mat-grid-tile>
            <mat-grid-tile rowspan="2" colspan="2">
              <mat-form-field class="formularTab" style="width:100%">
                <input matInput placeholder="Bemerkung" [(ngModel)]="pferd.Vorbehalt"  name="Vorbehalt">
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-tab>
      <div style="margin-bottom:20px">
        <mat-tab label="Einschätzung" style="width:800px ; min-height: 200px; " >
          <app-einschaetzung  [einschaetzung]="einschaetzung"  >Loading..</app-einschaetzung>
        </mat-tab>
      </div>
      <div style="margin-bottom:20px">
        <mat-tab label="Halterwechsel" style="width:800px ; min-height: 400px;" >
          <mat-form-field class="formularTab" style="margin-top:20px;">
            <mat-label>neuer Halter</mat-label>
            <input matInput placeholder="neuer Halter" [(ngModel)]="newHalter"  name="newHalter">
          </mat-form-field>
          <br>
            <button mat-flat-button [disabled]="newHalter.length<3" color="primary"(click)="searchNewHalter()" style="margin-left: 30px;" >Halter suchen ...</button>
            <br>
              <mat-form-field class="formularTab" style="margin-top: 20px">
                <mat-select  #newHalterField [(ngModel)]="pferd.PolicenNr" >
                  @for (option of newHalterList; track option) {
                    <mat-option   value="{{ option.PolicenNr }}">
                      {{ option.VN }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-tab>
            <br>
              {{pferd.PolicenNr}}
            </div>
          </mat-tab-group>
          <div style="text-align:center; margin-top:10px">
            <button mat-flat-button [disabled]="changedPferd()" color="primary"(click)="closePferd()" >schliessen</button>
            <button mat-flat-button [disabled]="!changedPferd()" color="primary"(click)="resetPferd()" style="margin-left: 30px;" >zurücksetzen</button>
            <button mat-flat-button [disabled]="!changedPferd()" color="primary"(click)="savePferd()" style="margin-left: 30px;" >speichern</button>
          </div>
        </div>
      }
